import React from "react";
import lazyLoad from "@/routers/utils/lazyLoad";
import { LayoutIndex } from "@/routers/constant";
import { RouteObject } from "@/routers/interface";
const enrollmentCenterRouter: Array<RouteObject> = [
	{
		element: <LayoutIndex />,
		meta: {
			title: "招生中心"
		},
		children: [
			{
				path: "/enrollmentCenter/intendedIearners",
				element: lazyLoad(React.lazy(() => import("@/views/enrollmentCenter/intendedIearners/index"))),
				meta: {
					requiresAuth: true,
					title: "意向学员",
					key: "intendedIearners"
				}
			}
		]
	}
];
export default enrollmentCenterRouter;
